export class Locale {
  code: string

  constructor(code: string) {
    this.code = code
  }
}
